import { get, patch, post } from "../axiosUitils";

const basePath = "/in-app-notifications";

// ── Types ────────────────────────────────────────────────────────────────────

export interface InAppNotificationExtra {
  sop_id?: string;
  feed_id?: string;
  sop_title?: string;
  [key: string]: any;
}

export interface InAppNotification {
  id: string;
  title: string;
  message: string;
  is_read: boolean;
  extra: InAppNotificationExtra;
  read_at: string | null;
  created_on: string;
  updated_on: string;
}

export interface InAppNotificationLinks {
  next: string | null;
  previous: string | null;
}

export interface InAppNotificationListResponse {
  links: InAppNotificationLinks;
  count: number;
  page: number;
  page_size: number;
  results: InAppNotification[];
}

export interface UnreadCountResponse {
  unread_count: number;
}

// ── Service ──────────────────────────────────────────────────────────────────

class NotificationService {
  /**
   * Fetch paginated list of in-app notifications.
   * @param page  Page number (default: 1)
   */
  getNotifications = async (
    page = 1
  ): Promise<InAppNotificationListResponse> => {
    const response = await get<InAppNotificationListResponse>(
      `${basePath}/`,
      {
        params: { page },
        notifyMessage: false,
      }
    );
    return response;
  };

  /**
   * Get the total count of unread notifications.
   */
  getUnreadCount = async (): Promise<number> => {
    const response = await get<UnreadCountResponse>(
      `${basePath}/unread-count/`,
      { notifyMessage: false }
    );
    return Number(response?.unread_count ?? 0);
  };

  /**
   * Mark a single notification as read and fetch its detail.
   * POST /in-app-notifications/{id}/read/
   */
  markAsRead = async (id: string): Promise<InAppNotification> => {
    const response = await post<any>(
      `${basePath}/${id}/read/`,
      {},
      { notifyMessage: false }
    );
    return response?.data;
  };

  /**
   * Mark ALL notifications as read.
   * POST /in-app-notifications/mark-all-read/
   */
  markAllAsRead = async (): Promise<void> => {
    await post(
      `${basePath}/mark-all-read/`,
      {},
      { notifyMessage: false }
    );
  };
}

const notificationService = new NotificationService();
export default notificationService;
